import React, { useState } from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import LanguageIcon from "./icons/LanguageIcon";
import { dropdownPartSx } from "../design/recipes/dropdown";
import { useRewampLocalization, useRewampT } from "../localisation";
import { APP_LANGUAGES, useAppLanguage } from "../hooks/useAppLanguage";

const MENU_ID = "language-menu";
const TRIGGER_ID = "language-menu-trigger";

const LanguageMenu = ({ sx }) => {
  useRewampLocalization(["common"]);
  const tRewamp = useRewampT();
  const { appLanguage, handleLanguageChange } = useAppLanguage();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const label = tRewamp("LANGUAGE_MENU.LABEL");
  const current = APP_LANGUAGES.find((lang) => lang.code === appLanguage) || APP_LANGUAGES[0];

  const handleSelect = (code) => {
    setAnchorEl(null);
    handleLanguageChange(code);
  };

  return (
    <>
      <Button
        id={TRIGGER_ID}
        variant="tertiary"
        size="small"
        startIcon={<LanguageIcon />}
        endIcon={<ExpandMoreIcon />}
        onClick={(e) => setAnchorEl(e.currentTarget)}
        aria-haspopup="menu"
        aria-expanded={open}
        aria-controls={open ? MENU_ID : undefined}
        aria-label={`${label}: ${current.name}`}
        sx={[(theme) => ({ minHeight: theme.spacing(3), minWidth: theme.spacing(3) }), ...(Array.isArray(sx) ? sx : [sx])]}
      >
        {current.short}
      </Button>
      <Menu
        id={MENU_ID}
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        slotProps={{ paper: { variant: "filterDropdownPanel" } }}
        MenuListProps={{ "aria-labelledby": TRIGGER_ID, "aria-label": label }}
      >
        {APP_LANGUAGES.map(({ code, name }) => {
          const selected = code === appLanguage;
          return (
            <MenuItem
              key={code}
              role="menuitemradio"
              aria-checked={selected}
              lang={code.split("_")[0]}
              onClick={() => handleSelect(code)}
              sx={[dropdownPartSx("filterDropdown", "option"), selected && dropdownPartSx("filterDropdown", "optionSelected")]}
            >
              {name}
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
};

LanguageMenu.propTypes = {
  sx: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.func]),
};

export default LanguageMenu;
